import { Routing, AppServices } from '@singularsystems/neo-core';
import { ReportingTypes } from '@singularsystems/neo-reporting';
import { ReportView } from '@singularsystems/neo-reporting';
import ClientReportsView from './ClientReports/ClientReportsView';
import MaintenanceReportsView from './MaintenanceReports/MaintenanceReportsView';
import { Reporting } from './Models/Security/Roles';
import NeoReportingService from './Services/NeoReportingService';

const NeoReportingAppModule = new AppServices.Module("Reporting", container => {
    container.bind(ReportingTypes.Services.ReportingService).to(NeoReportingService).inSingletonScope();
});

const NeoReportRoute: Routing.IMenuRoute =
{
    name: "Report",
    path: "/neoReport",
    component: ReportView,
    role: Reporting.Access
};

const NeoReportingPureRoutes = [NeoReportRoute];

// Routes
const NeoReportingRoutes: Routing.IMenuRoute =
{
    name: "Reports",
    expanded: false,
    icon: "file-alt",
    allowAnonymous:false,
    role: Reporting.Access,
    children: [
        {
            name: "Client Reports",
            path: "/clientReports",
            exact: true,
            component: ClientReportsView,
            icon: "file-alt",
            role: Reporting.Access,
            routeChildren:
                [
                    NeoReportRoute
                ]
         },
        {
            name: "Maintenance Reports",
            path: "/maintenanceReports",
            component: MaintenanceReportsView,
            icon: "file-alt",
            role: Reporting.Access,
            routeChildren:
                [
                    NeoReportRoute
                ]
        },
    ]
};

// Modules
export {
    NeoReportingAppModule,
    NeoReportingRoutes,
    NeoReportingPureRoutes
}